import {createFormContext} from '@mantine/form';
import {IOrderCreate} from "../../api/types";

export const [OrderFormProvider, useFormContext, useOrderForm] = createFormContext<IOrderCreate>();
